<div class="rx-card" >
    <div class="rx-card-title notes-title">
        <div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--justify-space-between rx-app-flex-container-row--align-center">
            <div class="rx-card-title-text">{{ 'NotesSection.Notes' | translate }}</div>
        </div>
    </div>
    <div class="rx-card-body notes-card-body">
        <form [formGroup]="notesForm">
            <div class="create-note rx-app-flex-container-row" *ngIf="!(this.isReadOnly$ | async) && !isPrintContext">
                <div class="note-form-field rx-app-flex--full">
                    <textarea
                        id="new-note"
                        [formControl]="newNote"
                        (blur)="blurNotes()"
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="3"
                        [placeholder]="'NotesSection.AddNote' | translate"
                        class="note-textarea note-textarea--outline"
                    >
                    </textarea>
                </div>
            </div>
            <ng-container formArrayName="notes">
                <div
                    *ngFor="let note of notes.controls; index as i"
                    class="mt-4 note-row rx-app-flex-container-row rx-app-flex-container-row--align-center"
                >
                    <div class="rx-app-flex rx-app-flex-container-column rx-app-flex-container-column--justify-center">
                        <div
                            id="note-title"
                            [ngClass]="!isPrintContext ? 'note-title-position' : 'note-title-position-print'"
                            class="note-title"
                        >
                            <span [id]="'note-created-by-name-' + i">{{ note.value.createdByName ? note.value.createdByName: ''  }}</span>
                            <div class="rx-app-flex-container-row rx-app-flex-container-row--justify-space-between rx-app-flex-container-row--align-center">
                                <span *ngIf="note.value.dateCreated" class="date-and-time mr-4">
                                    {{ note.value.dateCreated | date: (dateFormat$ | async) }}
                                    <span class="line-separator">|</span>
                                    {{ note.value.dateCreated | date: 'shortTime' }}</span
                                >
                                <span>
                                    <span *ngIf="i | mapper: canEdit.bind(this)" [id]="'edit-note-' + i" class="edit-note" (click)="editNote(i)">
                                        <mat-icon svgIcon="pencil_icon"></mat-icon>
                                    </span>
                                    <span *ngIf="i | mapper: canDelete.bind(this)" [id]="'remove-note-' + i" class="remove-note" (click)="removeNote(i)">
                                        <mat-icon svgIcon="trash_icon"></mat-icon>
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="note-content rx-app-flex-container-row">
                            <div class="note-form-field rx-app-flex--full" [class.read-only]="!(i | mapper: canEdit.bind(this))" [class.disabled]="!(i | mapper: isInEditableMode.bind(this))">
                                <ng-container [formGroup]="note">
                                    <textarea
                                        ngDefaultControl
                                        #noteinput
                                        (blur)="blurNotes()"
                                        formControlName="content"
                                        [id]="'notes-input-' + i"
                                        class="notes-input note-textarea"
                                        [class.hidden] = "isPrintContext"
                                        autocomplete="off"
                                        cdkTextareaAutosize
                                        cdkAutosizeMinRows="1"
                                        [placeholder]="'NotesSection.AddNote' | translate"
                                        [disabled]="!(i | mapper: canEdit.bind(this))"
                                    ></textarea>
                                    <div *ngIf="isPrintContext" class="print-notes-input">
                                        {{ note.value.content }}
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </form>
    </div>
</div>
